import React from 'react';
import {
  Edit,
  SimpleForm,
  DisabledInput,
  TextInput,
  ReferenceInput,
  SelectInput,
} from 'react-admin';
import { DateTimeInput } from 'react-admin-date-inputs';
import { required } from '../../lib/validation';

const redirect = (basePath, id, data) => `/users/${data.user_id}/show/subscriptions`;

const SubscriptionEdit = props => (
  <Edit {...props}>
    <SimpleForm redirect={redirect}>
      <DisabledInput label="ID" source="id" />
      <DateTimeInput
        label="Start at"
        source="start_at_europe"
        validate={required()}
        options={{ format: 'dd/MM/yyyy, HH:mm:ss' }}
      />
      <DateTimeInput
        label="End at"
        source="end_at_europe"
        validate={required()}
        options={{ format: 'dd/MM/yyyy, HH:mm:ss' }}
      />
      <DateTimeInput
        label="Payed at"
        source="payed_at_europe"
        options={{ format: 'dd/MM/yyyy, HH:mm:ss' }}
      />
      <TextInput label="Transaction" source="transaction_id" />
      <ReferenceInput label="Plan" source="plan_id" reference="plans">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="User" source="user_id" reference="users">
        <SelectInput optionText="full_name" options={{ disabled: true }} />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);

export default SubscriptionEdit;



// WEBPACK FOOTER //
// ./src/resources/subscriptions/SubscriptionEdit.jsx